// Faixa "Boletos vencidos" (pedido do Ruan, 08/10/2026): titulo a receber com boleto anexado,
// nao pago, vencido ha MAIS de 1 dia. Mesmo molde do AlertaContasPagarBanner — inclusive o X que
// dispensa ate amanha. A regra de quem entra mora so na rota (`/alertas-boletos-vencidos`).
import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Barcode, X } from 'lucide-react';
import { api } from '../lib/api';
import { useAuth } from '../lib/auth';
import { formatMoeda } from '@fiodecobre/shared';
import { useAlertaFaixa } from './alertas/AlertasContexto';

interface Resumo {
  qtd: number;
  total: string;
}

const POLLING_MS = 5 * 60 * 1000;
const KEY_DISMISS = 'boletos_vencidos.alerta.dismiss';
const FUNDO = '#f97316';
const BORDA = '#c2410c';
const TEXTO = '#000';

function dismissedHoje(): boolean {
  try {
    return localStorage.getItem(KEY_DISMISS) === new Date().toISOString().slice(0, 10);
  } catch {
    return false;
  }
}

export function AlertaBoletosVencidosBanner() {
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [resumo, setResumo] = useState<Resumo | null>(null);
  const [dismissed, setDismissed] = useState(dismissedHoje);

  // Mesmos perfis que anexam boleto ao titulo (rota `exigirPerfil('admin', 'gerente')`).
  const podeVer = usuario && ['admin', 'gerente'].includes(usuario.perfil);

  useEffect(() => {
    if (!podeVer) return;
    let cancelado = false;
    async function tick() {
      try {
        const r = await api.get<Resumo>('/api/contas-receber/alertas-boletos-vencidos');
        if (!cancelado) setResumo(r);
      } catch {}
    }
    void tick();
    const id = setInterval(tick, POLLING_MS);
    return () => { cancelado = true; clearInterval(id); };
  }, [podeVer]);

  const ativo = !!(podeVer && !dismissed && resumo && resumo.qtd > 0);

  const recolhido = useAlertaFaixa(
    'boletos-vencidos',
    ativo ? { rotulo: 'Boletos vencidos', bg: FUNDO, borda: BORDA, qtd: resumo!.qtd } : null,
  );

  if (!ativo || recolhido || !resumo) return null;

  function fechar() {
    try { localStorage.setItem(KEY_DISMISS, new Date().toISOString().slice(0, 10)); } catch {}
    setDismissed(true);
  }

  return (
    <div
      style={{
        background: FUNDO,
        borderLeft: `4px solid ${BORDA}`,
        color: TEXTO,
        padding: '8px 14px',
        display: 'flex',
        alignItems: 'center',
        gap: 10,
        fontSize: 13,
        cursor: 'pointer',
      }}
      onClick={() => navigate('/contas-receber?aba=boletos')}
    >
      <Barcode size={16} />
      <span style={{ fontWeight: 600 }}>Boletos vencidos:</span>
      <span>
        {resumo.qtd} titulo{resumo.qtd === 1 ? '' : 's'} com boleto vencido ha mais de 1 dia ({formatMoeda(resumo.total)})
      </span>
      <span style={{ marginLeft: 'auto', textDecoration: 'underline' }}>Ver lista</span>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); fechar(); }}
        title="Dispensar ate amanha"
        style={{ background: 'transparent', border: 'none', color: TEXTO, cursor: 'pointer', padding: 2 }}
      >
        <X size={14} />
      </button>
    </div>
  );
}
